import { FilterOrder, FilterOrders } from "#/organisms";
import {useCallback,  useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { Dashboard } from "@/components/pages";
import { DashboardCustomer } from "@/components/pages/DashboardCustomer";
import { DashboardWorker } from "@/components/pages/DashboardWorker";
import { OrderFilterParams } from "@/api/order/interface";
import { useApi } from "@/api";
import { useFilter } from "@/hooks";

const DashboardView = () => {
  const { customer, dashboard, invoice, order, session, worker } = useApi();
  const {
    filter,
    numberOfFilters,
    onOpenFilter,
    setShouldFilter,
    shouldFilter,
    showFilter,
    ...filterProps
  } = useFilter<FilterOrder>();
  const [loadingOrders, setLoadingOrders] = useState(false);
  const [called, setCalled] = useState(false);
  const [userType, setuserType] = useState(2);
  const [customerId, setcustomerId] = useState<string | null>(null);
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  let code = searchParams.get('code');
  let state = searchParams.get('state');
  
  useEffect(() => {
    const setXeroToken = async () => {
      if (!code && !state) {
        const urlParams = new URLSearchParams(window.location.search);
        code = urlParams.get('code');
        state = urlParams.get('state');
        window.history.replaceState({}, '', `${window.location.pathname}`);
      }

      if (code && state) {
        await invoice.connectXero(code);
        navigate('/generate-invoices', { replace: true });
      }
    }
      
    setXeroToken();      
  }, [code, state]);

  const getOrders = useCallback(async (userTypeInput: number, filterData?: OrderFilterParams) => {
    setLoadingOrders(true);

    filterData && (filterData.maintainerId = 'not-set');

    if (customerId) {
      filterData && (filterData.customerId = customerId);
    }

    if (userTypeInput === 2) {
      await order.getBranchOrders(filterData);
    }
    else if (userTypeInput === 3) {
      await worker.getOrderList(filterData);
    }

    setLoadingOrders(false);
  }, [customerId])

  const getDashboardData = async () => {
    await dashboard.getDashboardData();
  }

  useEffect(() => {

    if (!called)
      {
       setCalled(true);
      }

    if (session.hasAdminRole()) {
      setuserType(1);
      getDashboardData();
    }
    else if (session.hasWorkerRole()) {
      setuserType(3);
      setCalled(true);
      getOrders(3, {
      });
    }
    else if (session.hasCustomerRole()) {
      customer.getBranches(session?.user?.id ?? '').then((resp) => {
        
        const respCustId = resp[0].BranchId.toString();

        setcustomerId(respCustId);

        if (order.orders.length === 0 || !called) {
          setCalled(true);
          getOrders(2, {
            customerId: respCustId
          });
        }
      });
    }
  }, [called]);

  useEffect(() => {
    if (shouldFilter) {
      if (filter) {
        getOrders(userType, filter && {
          customerCode: filter.customerCode,
          customerEmail: filter.customerEmail,
          customerName: filter.companyName,
          dateFrom: filter.dateFrom,
          dateTo: filter.dateTo,
          orderId: filter.jobNumber,
          orderState: filter.state || null,
          propertyAddress: filter.location,
        });
      } else {
        getOrders(userType, {
        });
      }
      setShouldFilter(false);
    }
  }, [filter, shouldFilter, userType]);

    const handleCreateNewOrder = useCallback((pkgid?: number) => {
      if (pkgid)
      {
        navigate(`/order-new/brid=${customerId}/pkgid=${pkgid}`);
      }
      else {
        navigate(`/packages/action=new-order`);
      }
    }, [customerId]);
  
    const handleSelectOrderCustomer = useCallback((orderId: string) => {
      navigate(`/order-view/order=${orderId}`);
    }, []);
  
    const handleSelectOrderWorker = useCallback((orderId: string) => {
      navigate(`/order-view-worker/order=${orderId}`);
    }, []);

  return (
    <>
      {userType === 1 &&
        (<Dashboard dashboardData={dashboard.dashboardData} firstName={session?.user?.firstName} />)
      }
      {userType === 2 &&
        (<>
          <DashboardCustomer firstName={session?.user?.firstName} lastName={session?.user?.lastName} loading={loadingOrders}
            numberOfFilters={numberOfFilters}
            orders={order.orders}
            onCreateNewOrder={handleCreateNewOrder}
            onOpenFilter={onOpenFilter}
            onSelectOrder={handleSelectOrderCustomer} />
          {showFilter && <FilterOrders {...filterProps} filter={filter} numberOfFilters={numberOfFilters} showAdminFilter={false} />}
        </>)
      }
      {userType === 3 &&
        (<DashboardWorker firstName={session?.user?.firstName} lastName={session?.user?.lastName} loading={loadingOrders}
            numberOfFilters={numberOfFilters}
            orders={worker.workerOrders}
            onOpenFilter={onOpenFilter}
            onSelectOrder={handleSelectOrderWorker} />)
      }
    </>
  );
}

export default DashboardView;